// extracted by mini-css-extract-plugin
export default {"container":"ConsentLogs_container__nR+jE","logs":"ConsentLogs_logs__yVw2c","close":"ConsentLogs_close__OBJp-"};